import React from 'react';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { colors } from '_styles';
import { connect } from 'react-redux';
import CircularProgressbar from './CircularProgressBar';

const View = styled.div`
  box-sizing: border-box;
`;

const RadioCircle = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 50%;
  margin-right: 18px;
  position: relative;
  cursor: 'pointer';
  background-color: #fff ;
  transform: scale(0.5);

  &.answered {
    &:before{
      content: '';
      position: absolute;
      top: 9px;
      left: 9px;
      right: 9px;
      bottom: 9px;
      margin: auto;
      border-radius: 50%;
      background-color: ${colors.RC_ACTION};
    }
    &:after{
      content: '';
      position: absolute;
      top: 9px;
      left: 9px;
      right: 9px;
      bottom: 9px;
      margin: auto;
      border-radius: 50%;
      // background-color: ${colors.RC_ACTION};
      background-color: #0086C2;
    }
  }
`;

const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 6px;
  box-sizing: border-box;
  padding-left: 0;
  height: 44px;
`;

const RowContainer = styled.div`
  flex-direction: column;
`;

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const CircularProgressbarContainer = styled.div`
  margin-left: auto;
`;

const OptionText = styled.span`
  font-weight: 400 !important;
  font-size: 16px !important;
  color: #404040 !important;
  word-break: break-word;
  white-space: pre-wrap;
  margin-right: 10px;
`;

const Feedback = styled.div`
  font-size: 16px !important;
  margin-top: 5px;
  margin-bottom: 10px;
  animation: ${OpacityAnimation} 0.7s;
  text-align: left !important;

  &.correct {
    color: ${colors.RC_GREEN} !important;
  }
  &.false {
    color: ${colors.RC_RED} !important;
  }
`;

const PollRow = ({
  pressHandler,
  title,
  index,
  answer,
  isCorrect,
  disabled,
  coachableId,
  correctOption,
  selectedOption,
  optionValue,
  optionStat
}) => (
  <View>
    <RowContainer>
      <OptionContainer
        onClick={() => ((!disabled) ? pressHandler(coachableId) : null)}
      >
        <RadioCircle
          aria-label={optionStat && optionStat.length ? `${title} ${optionStat[index]}%` : title}
          className={answer || (Number(index + 1) === Number(selectedOption)) ? 'answered' : ''}
        />
        <OptionText aria-hidden>
          {/* {`Too long Text Too long Text Too long Text Too long
          Text Too long Text Too long Text,${title}`} */}
          {title}
        </OptionText>
        {
          optionStat
            && Number(index + 1) === Number(selectedOption)
            && optionStat.length
            ? (
              <CircularProgressbarContainer>
                <CircularProgressbar percentage={optionStat[index] - 1} storkeColor="#0086C2" />
              </CircularProgressbarContainer>
            ) : null
        }
        {
          optionStat
            && !(Number(index + 1) === Number(selectedOption))
            && optionStat.length
            ? (
              <CircularProgressbarContainer>
                <CircularProgressbar percentage={optionStat[index] - 1} storkeColor="#a9a9a9" />
              </CircularProgressbarContainer>
            ) : null
        }
      </OptionContainer>
      {
        answer
        && isCorrect
        && (
          <Feedback className="correct">
            <span>
              {_('resources.you_got_it_right')}
            </span>
          </Feedback>
        )
      }
      {
        answer
        && !isCorrect
        && (
          <Feedback className="false">
            <span>
              {_('resources.oops_wrong_answer')}
            </span>
          </Feedback>
        )
      }
      {
        disabled
        && Number(correctOption) === Number(optionValue.split('_')[optionValue.split('_').length - 1]) // This option is the correct one, this is for showing the user the correct answer
        && !answer
        && (
          <Feedback className="correct">
            <span>
              {_('resources.heres_the_right_answer')}
            </span>
          </Feedback>
        )
      }
    </RowContainer>
  </View>
);

const mapStateToProps = (store) => ({
  selectedLang: store.config.selectedLang,
});

export default connect(mapStateToProps)(PollRow);
